import { render, staticRenderFns } from "./VerificationDetail.vue?vue&type=template&id=651f1118&"
import script from "./VerificationDetail.vue?vue&type=script&lang=js&"
export * from "./VerificationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports